// extracted by mini-css-extract-plugin
module.exports = {"CL_container":"List-module__CL_container","CL_list":"List-module__CL_list","partnersButton":"List-module__partnersButton"};